module.exports = __webpack_public_path__ + "static/media/dish.7b533077.svg";